import moment from 'moment';
import { EditLiabilityFormInputs } from 'fragments/property-card/create-edit-liability/interfaces';
import {
    AritmeticOperation,
    LiabilityDto,
    LiabilityInstance,
    LiabilityPaymentTerm,
} from 'services/liabilities/liabilities.service';

export const mapLiabilityToEditFormInputs = (liability: LiabilityDto): EditLiabilityFormInputs | undefined => {
    if (!liability.liabilityType || !liability.id || !liability.type?.id) {
        return undefined;
    }

    const initialValues = {
        id: liability.id,
        name: liability.name,
        uniqueOrRecurrent: 'recurrent',
        payerType: liability.payerType,
        paymentTerm: liability.paymentTerm ?? LiabilityPaymentTerm.CURRENT_MONTH,
        serviceTypeId: liability.type.id,
        showInReceipt: liability.showInReceipt ?? false,
        showInSettlement: liability.showInSettlement ?? false,
        defaultAmount: liability.defaultAmount,
        observation: liability.observation,
        receiptOperation: liability.receiptOperation ?? AritmeticOperation.SUBSTRACT,
        settlementOperation: liability.settlementOperation ?? AritmeticOperation.SUBSTRACT,
    };

    if (liability.liabilityType == LiabilityInstance.CONTRACT_LIABILITY) {
        const fromDate = moment().set({ year: liability.fromYear, month: (liability.fromMonth ?? 1) - 1 });
        const toDate = moment().set({ year: liability.toYear, month: (liability.toMonth ?? 1) - 1 });
        return {
            ...initialValues,
            indeterminateTime: false,
            uniqueOrRecurrent: 'recurrent',
            monthDuration: [fromDate, toDate],
        };
    }

    if (liability.liabilityType == LiabilityInstance.PROPERTY_LIABILITY) {
        return {
            ...initialValues,
            indeterminateTime: true,
            uniqueOrRecurrent: 'recurrent',
        };
    }

    // FOLLOW_UP_LIABILITY
    return {
        ...initialValues,
        uniqueOrRecurrent: 'unique',
    };
};
